angular.module('storefrontApp')
    .component('rsPasswordRequirements', {
        templateUrl: 'themes/assets/js/common-components/rsPasswordRequirements.tpl',
        bindings: {
            password: '=',
            isValid: '=',
        },
        controller: ['$scope', function ($scope) {
            const ctrl = this;

            ctrl.passwordPatterns = {
                min: /.{8,}/,
                numbers: /[0-9]/,
                upper: /[A-Z]/,
                lower: /[a-z]/,
                symbols: /[^a-z^A-Z^\d]/,
                nonRepeated: /^(?!.*(.)\1{1,}).+$/,
            };

            ctrl.testLength = function () {
                if (!ctrl.password) {
                    return false;
                }
                return ctrl.passwordPatterns.min.test(ctrl.password);
            };

            ctrl.testContent = function () {
                if (!ctrl.password) {
                    return false;
                }

                let matched = 0;

                matched += ctrl.passwordPatterns.upper.test(ctrl.password) ? 1 : 0;
                matched += ctrl.passwordPatterns.lower.test(ctrl.password) ? 1 : 0;
                matched += ctrl.passwordPatterns.numbers.test(ctrl.password) ? 1 : 0;
                matched += ctrl.passwordPatterns.symbols.test(ctrl.password) ? 1 : 0;

                return matched >= 4;
            };

            ctrl.testRepeat = function () {
                if (!ctrl.password) {
                    return false;
                }
                return ctrl.passwordPatterns.nonRepeated.test(ctrl.password);
            };

            $scope.$watch('$ctrl.password', function () {
                ctrl.matchLength = ctrl.testLength();
                ctrl.matchContent = ctrl.testContent();
                ctrl.matchRepeat = ctrl.testRepeat();
                ctrl.isValid = ctrl.matchLength && ctrl.matchContent && ctrl.matchRepeat;
            });
        }],
    });
